export default function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <span>Never trust a computer you can't throw out a window</span>
        <span>- Steve Wozniak</span>
      </div>
    </footer>
  );
}